module.exports = __webpack_public_path__ + "img/list-title-w.f1fb62ae.png";